export default "__VITE_ASSET__B969PCkp__"